import { IOrderDetails } from './types';
import { getCurrencyNameOrSymbol } from '../../../../utils/currency';
import { InitialUrlSearchParams } from '../../../../utils/environment';

export const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});

export const getOrderCountryCode = (order: IOrderDetails): string => {
  return (
    order.shipping_address?.country_code ||
    order.segments?.[0]?.store_location?.country_code ||
    order.billing_address?.country_code ||
    'US'
  );
};

export const formatAmount = (amount: number, orderShippingCountryCode: string, shouldShowDecimals = true) => {
  // Show 2 decimals if the number has decimal places, otherwise show none (unless shouldShowDecimals is true)
  const locale = `en-${orderShippingCountryCode}`;
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: shouldShowDecimals ? 2 : amount % 1 !== 0 ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

// only return symbol if it's different from the currency code (e.g. $ for USD, but no symbol for AED since it's the same as the code)
export const getCurrencySymbolOnly = (currencyCode: string): string => {
  const currencyNameOrSymbol = getCurrencyNameOrSymbol(currencyCode, 'narrowSymbol');
  return currencyNameOrSymbol === currencyCode ? '' : currencyNameOrSymbol;
};

// Updates URL parameters and replaces browser history state
export const updateBrowserHistoryState = (updates: Record<string, string | null>) => {
  Object.entries(updates).forEach(([key, value]) => {
    value === null ? InitialUrlSearchParams.delete(key) : InitialUrlSearchParams.set(key, value);
  });
  window.history.replaceState(
    {},
    '',
    window.location.origin + window.location.pathname + '?' + InitialUrlSearchParams.toString()
  );
};

export const toLocalDate = (utc_date: string): string => {
  try {
    const utcDate = new Date(utc_date);
    return dateFormatter.format(utcDate);
  } catch (error) {
    // Any unexpected failure fallback
    console.error('Error parsing order_placed_utc:', error);
    return utc_date;
  }
};
